import type { FaireProductEntity } from "../../entity_types/product";

export const p_52tpup8tur: FaireProductEntity = {
  token: "p_52tpup8tur",
  type: "product",
  name: "Peach Blossom Assorted Notecard Set",
  brandToken: "b_5fe9uukyn9",
  brandName: "Paper Farm Press",
  imageUrl:
    "https://cdn.faire.com/fastly/fed414d31d6139e8c55dc216657325e8fb7ddfff0aae0e4e112c5b6605ee37ee.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8dc4dc4929709daf612a180655a43231fdb85cf2618f42092ceed9d48017a28e.jpeg",
    "https://cdn.faire.com/fastly/360a59d0faff84d36153d45aa752717094f94db752d4392ba6980aaa117ea789.jpeg",
    "https://cdn.faire.com/fastly/066413462108802f9861aa809a033c64871deaed31bacb887fcaf06e1b0c774f.jpeg",
    "https://cdn.faire.com/fastly/212b4143502e56c656477c8e2b9f9433b5f856189ff41c675fba75e263560eee.jpeg",
  ],
  priceDollars: 7.5,
  description:
    'Introducing the Peach Blossom Assorted Notecard Set! The cutest phrases on the most adorable scalloped edge notecards, with colored envelopes, hide in this best-selling assorted notecard set! With an adorable peach blossom theme design, these cards are perfect for sending to friends and family for all of life\'s many occasions. A great choice for pen pals and lovers of snail mail. Ideal for orchard gift shops, festivals farmers markets, and more!\n\n• Size l 5x6\n• Count l 12 flat, scalloped edge notecards. Colored envelopes. 2 each of 6 designs.\n• Features l Scalloped edge notecards, coordinating colored envelopes, beautiful peach-patterned box\n• Sentiments l "Sweet as a peach" "Thank you so much" "Hope your day is just peachy" "Much ap-peach-iated" "You\'re a peach" "Let your dreams blossom"',
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:22.192Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
